const serverBaseURL = "https://enerscale.co/api/dbn/";
// const serverBaseURL = 'http://127.0.0.1:8000/api/dbn/';
const googleMapKey = "AIzaSyCMRlsJIkTmawGuiXktiAnHHWCm3Axt7r8";

export { googleMapKey, serverBaseURL };
